const APP_INSTANCE_ID = 'APP_INSTANCE_ID'

export function getAppInstanceId(): string | null {
  return window.sessionStorage.getItem(APP_INSTANCE_ID)
}

export function setAppInstanceId(appInstanceId: string): void {
  window.sessionStorage.setItem(APP_INSTANCE_ID, appInstanceId)
}
